/* =================== PORTFÓLIO HOME =================== */
$(function () {
  $(".carrosel-fotos").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    autoplay: false,
    //autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: false,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
        },
      },
    ],
  });
});
